import React from 'react';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, Button } from '@tq/ui-components';

type DrawerItemProps = {
  onClick: () => void;
  rightIcon?: React.ReactElement;
  text: string;
};

export const MobileMenuDrawerItem: React.FC<DrawerItemProps> = ({
  onClick,
  rightIcon,
  text,
}) => {
  return (
    <Box
      height='4rem'
      minHeight='4rem'
      width='100%'
      backgroundColor={COLOURS.white}
      borderBottom='none'
      color={COLOURS.blue[600]}
      _active={{ backgroundColor: COLOURS.neutral[5] }}
      _hover={{ backgroundColor: COLOURS.white }}
      _focus={{
        outline: 'none',
        borderColor: 'transparent',
        backgroundColor: COLOURS.neutral[5],
      }}
      onClick={onClick}
    >
      <Button
        variant='tertiary'
        w='full'
        h='full'
        px='2rem'
        borderRadius={0}
        border='none'
        fontWeight='semibold'
        fontSize='lg'
        display='flex'
        alignItems='center'
        justifyContent='space-between'
      >
        <Box>{text}</Box>
        {rightIcon}
      </Button>
    </Box>
  );
};
